const MM_PER_INCH = 25.4

export const PRINT_DPI = 300
export const BUILDER_IMAGE_MAX_PIXEL_DIMENSION = 2400

export const mmToPrintPixel = (mm, dpi = PRINT_DPI) => Math.round((mm * dpi) / MM_PER_INCH)

export const getBuilderBackgroundResizeOptions = (widthMm, heightMm) => ({
  width: mmToPrintPixel(widthMm),
  height: mmToPrintPixel(heightMm),
})

export const getBuilderImageResizeOptions = () => ({
  width: BUILDER_IMAGE_MAX_PIXEL_DIMENSION,
  height: BUILDER_IMAGE_MAX_PIXEL_DIMENSION,
})
